import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Pill, ShoppingCart, Receipt, Truck, LogOut, Cross, BarChart3, Settings as SettingsIcon, Users, RotateCcw, Undo, BookOpen, Tags } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/billing", label: "Billing / POS", icon: Receipt, testid: "nav-billing" },
  { to: "/sales-returns", label: "Sales Returns", icon: Undo, testid: "nav-sales-returns" },
  { to: "/customer-accounts", label: "Credit Accounts", icon: BookOpen, testid: "nav-customer-accounts" },
  { to: "/inventory", label: "Inventory", icon: Pill, testid: "nav-inventory" },
  { to: "/categories", label: "Categories", icon: Tags, testid: "nav-categories" },
  { to: "/purchases", label: "Purchases", icon: ShoppingCart, testid: "nav-purchases" },
  { to: "/purchase-returns", label: "Purchase Returns", icon: RotateCcw, testid: "nav-purchase-returns" },
  { to: "/suppliers", label: "Suppliers", icon: Truck, testid: "nav-suppliers" },
  { to: "/patients", label: "Patients", icon: Users, testid: "nav-patients" },
  { to: "/reports", label: "Reports", icon: BarChart3, testid: "nav-reports" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="h-screen overflow-hidden flex bg-background">
      <aside className="sticky top-0 h-screen w-60 shrink-0 border-r border-border bg-white flex flex-col" data-testid="sidebar">
        <div className="p-5 border-b border-border">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-primary text-primary-foreground grid place-items-center">
              <Cross size={18} strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-semibold tracking-tight" style={{ fontFamily: "Chivo" }}>MediLedger</div>
              <div className="text-[11px] text-muted-foreground uppercase tracking-widest">Pharmacy Suite</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 min-h-0 overflow-y-auto p-3 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 ${isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground hover:bg-muted"
                }`
              }
            >
              <it.icon size={16} />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-border">
          <div className="text-xs text-muted-foreground mb-2 truncate" data-testid="current-user-email">
            {user?.email}
          </div>
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm bg-secondary hover:bg-muted transition-colors"
          >
            <LogOut size={14} /> Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 h-screen overflow-y-auto noise-bg">
        <div className="max-w-[1400px] mx-auto h-full min-h-0 p-6">{children}</div>
      </main>
    </div>
  );
}
